'use client'
import React, { createContext } from 'react'
import { ThemeProvider as StyledComponentProvider } from 'styled-components'
import { getTheme } from './../../utils'
import type { ThemeContextType, ThemeProviderProps } from './type'
import CleartripTheme from '../../token/theme/CleartripTheme'

export const ThemeContext = createContext<ThemeContextType>({
    theme: CleartripTheme,
    platform: 'mobile'
})

const ThemeProvider = ({
    children,
    theme: themeType = 'B2C',
    platform = 'mobile'
}: ThemeProviderProps): JSX.Element => {
    const theme = getTheme(themeType)
    return (
        <ThemeContext.Provider value={{ theme, platform }}>
            <StyledComponentProvider theme={theme}>
                <>{children}</>
            </StyledComponentProvider>
        </ThemeContext.Provider>
    )
}

ThemeProvider.defaultProps = {
    children: null
}

export default ThemeProvider
